import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { debounceTime, first } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
@Component({
  selector: 'app-withdrawal-paypal',
  templateUrl: './withdrawal-paypal.component.html',
  styleUrls: ['./withdrawal-paypal.component.scss'],
})
export class WithdrawalPaypalComponent extends WithdrawalBaseComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  public error = null;
  public hasAccount: boolean = false;

  public withdrawalForm: FormGroup;
  public amount: AbstractControl;
  public selectedAccount: AbstractControl;
  public customerAccountID: AbstractControl;
  public currency_code: AbstractControl;
  public payment_type_code: AbstractControl;
  public accounts: any = [];
  public accountBalances: BalanceModel;
  public isPageLoaded: boolean = false;
  public buttonDisabled:boolean = false;
  public enterCounts = 0;
  public labels: DepositMainLabels;
  public enterPressed: boolean;

  constructor(
    public addressService: AddressService,
    public appLinks: AppLinksService,
    public events:EventsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService,
    public balanceService:AccountBalanceService,
    public withdrawService:WithdrawalService,
    public navigator:Navigator,
    public utils:UtilsService
  ){ 
    super();
    this.successMessageService.clearMessage();
    this.error = null;    
    this.labels = new DepositMainModel();
  }

    ngOnInit() {
        this.buttonDisabled = false;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                customerAccountID: new FormControl(''),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )
        this.amount = this.withdrawalForm.get('amount');

        this.onGetBalance();
        this.onGetAccounts();
    }

    ngAfterViewInit(){
        this.cashierContentService.getPageConfig('paypal').then((response: DepositMainLabels) => {
            this.labels = response;
        });
    }
    
    onGetBalance() {
        this.balanceService.getBalance().pipe(first()).subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );
        this.error = null;
    }

    onGetAccounts() {
        this.accounts = [];
        this.cashierService.callListAccounts().subscribe(
            (response) => {
                if (response.result) {
                    this.accounts = response.payload.filter(
                        account => account.paymentTypeCode == "PPD"
                    );
                    if(this.accounts.length) this.hasAccount = true;
                }
                else {
                    // this.logger.error('Failed to get accounts');
                }
                    
                this.isPageLoaded = true;
            }
        );
    }

    submit() {
        this.buttonDisabled = true;
        this.checkEnterSubmission();
    }

    checkEnterSubmission() {
        if(this.enterPressed === true){
            if(this.enterCounts == 1){
                setTimeout(() => { this.onWithdraw() }, 200);
            }
            this.buttonDisabled = false;  
            this.enterPressed = false;
            
        }else {
            setTimeout(() => { this.onWithdraw() }, 200);
        } 
    }

    onWithdraw() {
        this.buttonDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;

        this.withdrawalForm.get("customerAccountID").setValue(this.accounts[0].customerAccountID);
        this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("PPD");

        this.withdrawService.callWithdraw(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe(
            (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result ) {
                    let depositEventData: AffiliateTrackerCallbackParams = {
                        customer_id: this.cashierService.customer.customerId,
                        amount:     this.withdrawalForm.get('amount').value
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);
                    this.amount.setValue('');
                    this.amount.markAsPristine();
                    this.amount.markAsUntouched();

                    this.successMessageService.setMessage('Your withdrawal request has been received.');

                    this.balanceService.updateBalance();

                    this.balanceService.getBalance().subscribe(
                        (balance: BalanceModel) => {
                            if (balance) {
                                this.accountBalances = balance;
                            }
                        }
                    );

                    this.content.scrollToTop();
                    this.buttonDisabled = false;
                }
            },
            (error) => {
                this.buttonDisabled = false;
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callWithdraw error = ", error);
            }
        )
        // Clearing the enterCounts after 3 seconds each time a withdrawal request is made.
        setTimeout(()=> {
            this.enterCounts = 0;
        },3000);

        this.error = null;
    }

    public onWhatIsPaypal(): any {
        let url = this.configService.getConfig().FEATURE_PAYPAL_INFO;
        return this.appLinks.openExternalPage(url);
    }

    public toPayPalDeposit(): any{
    return this.navigator.navigateTo("DepositPaypalComponent", {}, { navigateBackPage: "WithdrawalPaypalComponent" });
    }

}
